const commonPrescribedMedicinesUK = [
    "Paracetamol",
    "Ibuprofen",
    "Aspirin",
    "Amoxicillin",
    "Co-amoxiclav",
    "Simvastatin",
    "Amlodipine",
    "Lisinopril",
    "Levothyroxine",
    "Atorvastatin",
    "Ramipril",
    "Metformin",
    "Omeprazole",
    "Salbutamol",
    "Fluticasone",
    "Sertraline",
    "Lansoprazole",
    "Prednisolone",
    "Citalopram",
    "Gliclazide",
    "Warfarin",
    "Rivaroxaban",
    "Losartan",
    "Furosemide",
    "Diazepam",
    "Amitriptyline",
    "Metoprolol",
    "Mirtazapine",
    "Loratadine",
    "Tamsulosin",
    "Esomeprazole",
    "Fluoxetine",
    "Candesartan",
    "Fentanyl",
    "Tramadol",
    "Morphine",
    "Gabapentin",
    "Pregabalin",
    "Atenolol",
    "Bisoprolol",
    "Ciprofloxacin",
    "Doxycycline",
    "Flucloxacillin",
    "Methotrexate",
    "Duloxetine",
    "Escitalopram",
    "Venlafaxine",
    "Bupropion",
    "Carbamazepine",
    "Lamotrigine",
    "Quetiapine",
    "Haloperidol",
    "Aripiprazole",
    "Risperidone",
    "Heparin",
    "Enoxaparin",
    "Clopidogrel",
    "Dabigatran",
    "Ezetimibe",
    "Glimepiride",
    "Insulin (various types)",
    "Montelukast",
    "Rosuvastatin",
    "Alendronic acid",
    "Metronidazole",
    "Cefuroxime",
    "Azithromycin",
    "Levofloxacin",
    "Fluconazole",
    "Aciclovir",
    "Ranitidine",
    "Pantoprazole",
    "Bisacodyl",
    "Loperamide",
    "Rabeprazole",
    "Docusate sodium",
    "Senna",
    "Lactulose",
    "Clozapine",
    "Olazapine",
    "Lithium",
    "Valproate",
    "Methadone",
    "Suboxone (Buprenorphine/Naloxone)",
    "Clonazepam",
    "Lorazepam",
    "Zopiclone",
    "Eszopiclone",
    "Modafinil",
    "Methylphenidate",
    "Atomoxetine",
  ];

  export default commonPrescribedMedicinesUK